module.exports = __webpack_public_path__ + "static/media/Amanda Bartle.3364b6f0.JPG";